'use client'

import clsx from 'clsx'
import { motion } from 'motion/react'
import Link from 'next/link'
import { PropsWithChildren } from 'react'
import { UrlObject } from 'url'
import styles from './NavigationLink.module.scss'

type Props = {
  text: string
  href: string | UrlObject
  isDark?: boolean
}

const NavigationLink = ({ text, href, isDark = false }: PropsWithChildren<Props>) => {
  const handleClick = () => {
    sessionStorage.setItem('scrollY', window.scrollY.toString())
  }

  const variants = {
    hidden: { opacity: 0, transition: { duration: 0.2 } },
    enter: { opacity: 1, transition: { duration: 0.2 } },
    exit: { opacity: 0, transition: { duration: 0.2 } },
  }

  return (
    <Link href={href} scroll={true} passHref onClick={handleClick}>
      <motion.div className={clsx(styles.link, isDark && styles.dark)} variants={variants} initial='hidden' animate='enter'>
        {text}
      </motion.div>
    </Link>
  )
}

export default NavigationLink
